import posthog from 'posthog-js';
import { useEffect } from 'react';

import type { Step } from './OnboardingSteps';

const BASE_DOC_TITLE = 'Qalico';

const STEP_DOC_TITLES: Partial<Record<Step, string>> = {
  'url-input': 'Enter company website',
  loading: 'Generating profile',
  review: 'Review company profile',
  products: 'Review products',
  matching: 'Finding applicable sources',
  results: 'Review applicable sources',
  email: 'Create your account',
};

/**
 * PostHog is initialized only in production (see PosthogProvider).
 */
export function captureRegulatoryOnboardingEvent(
  event: string,
  properties?: Record<string, unknown>
): void {
  if (!import.meta.env.PROD || !import.meta.env.VITE_PUBLIC_POSTHOG_KEY) return;
  try {
    posthog.capture(event, properties);
  } catch {
    // PostHog may not be initialized yet (e.g. first paint before provider runs)
  }
}

export function useRegulatoryOnboardingDocumentTitle(step: Step): void {
  useEffect(() => {
    const fragment = STEP_DOC_TITLES[step];
    if (fragment) {
      document.title = `${fragment} — ${BASE_DOC_TITLE}`;
    }
    return () => {
      document.title = `${BASE_DOC_TITLE} - SaaS Dashboard`;
    };
  }, [step]);
}
